import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.joystick');
import { OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-joystick',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.joystick/view.scss */
:host {
  display: block;
}

.joystick-base {
  touch-action: none;
}

.jump-btn {
  -webkit-tap-highlight-color: transparent;
}
.jump-btn:active {
  background: rgba(255, 255, 255, 0.25);
}

@media (max-width: 768px) {
  .joystick-base {
    width: 6.25rem !important;
    height: 6.25rem !important;
  }
  .joystick-thumb {
    width: 2.5rem !important;
    height: 2.5rem !important;
  }
  .jump-btn {
    width: 3rem !important;
    height: 3rem !important;
  }
}`],
})
export class ComponentJoystickComponent implements OnInit {
    @Input() isMobile: boolean = false;
    @Output() directionChange = new EventEmitter<{ [key: string]: boolean }>();
    @Output() jump = new EventEmitter<void>();

    public joystickThumbX: number = 0;
    public joystickThumbY: number = 0;
    private joystickActive: boolean = false;
    private joystickCenterX: number = 0;
    private joystickCenterY: number = 0;
    private JOYSTICK_RADIUS: number = 50;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public onJoystickStart(event: TouchEvent) {
        event.preventDefault();
        const touch = event.touches[0];
        const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
        this.joystickCenterX = rect.left + rect.width / 2;
        this.joystickCenterY = rect.top + rect.height / 2;
        this.joystickActive = true;
        this.updateJoystick(touch.clientX, touch.clientY);
    }

    public onJoystickMove(event: TouchEvent) {
        event.preventDefault();
        if (!this.joystickActive) return;
        const touch = event.touches[0];
        this.updateJoystick(touch.clientX, touch.clientY);
    }

    public onJoystickEnd(event: TouchEvent) {
        event.preventDefault();
        this.joystickActive = false;
        this.joystickThumbX = 0;
        this.joystickThumbY = 0;
        this.directionChange.emit({});
    }

    private updateJoystick(touchX: number, touchY: number) {
        let dx = touchX - this.joystickCenterX;
        let dy = touchY - this.joystickCenterY;
        const dist = Math.sqrt(dx * dx + dy * dy);
        if (dist > this.JOYSTICK_RADIUS) {
            dx = dx / dist * this.JOYSTICK_RADIUS;
            dy = dy / dist * this.JOYSTICK_RADIUS;
        }
        this.joystickThumbX = dx;
        this.joystickThumbY = dy;

        const deadzone = 15;
        const keys: { [key: string]: boolean } = {};
        keys['left'] = dx < -deadzone;
        keys['right'] = dx > deadzone;
        keys['up'] = dy < -deadzone;
        keys['down'] = dy > deadzone;
        this.directionChange.emit(keys);
    }

    public onJoystickJump(event: TouchEvent) {
        event.preventDefault();
        this.jump.emit();
    }
}

export default ComponentJoystickComponent;